const styles = () => ({
    icon: {
        height: 190,
        width: 313,
    },
});

export default styles;
